import { StatusChangeByComponentView } from "./StatusChangeByComponentView.model";

export class RequestStatusAgencyExtraWarrantyView extends StatusChangeByComponentView {
    public StartDate: Date;
    public EndDate: Date;
    public WarrantyNumber: string;
    public WarrantyType: number;   
    public File: string;
    
}